import { Component, OnInit } from "@angular/core";
import { MessageService } from "primeng/api";
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef,
} from "primeng/dynamicdialog";
import {
  AggregateSharesValidationEntry,
  DuplicateFilingsEntryDetails,
  DuplicateFilingSubmissionStatus,
  QualityGateDetailsFilter,
  QualityGateEntryDetails,
  QualityGateFilter,
  QualityGateSubmission,
} from "src/api/models";
import { QualityGateService } from "src/api/services";

@Component({
  selector: "app-view-filings",
  // imports: [],
  templateUrl: "./view-filings.component.html",
  styleUrl: "./view-filings.component.css",
  standalone: false,
})
export class ViewFilingsComponent implements OnInit {
  readonly paginator = { pageSize: 10, pageNumber: 1, totalCount: 0 };
  duplicateFilingsEntryDetails: DuplicateFilingsEntryDetails[] = [];
  selectedAggregateShares: any[] = [];
  selectedFiling: any;
  first = 0;
  rows = 10;
  isLoading: boolean = false;
  issuerName?: string;
  filingId?: number;
  insiderName?: string;
  groupFlagChecked = false;
  constructor(
    private _qualityGateService: QualityGateService,
    public dialogService: DialogService,
    private _messageService: MessageService,
    public config: DynamicDialogConfig,
    public ref: DynamicDialogRef
  ) {}
  ngOnInit(): void {
    this.selectedFiling = this.config.data.fileDetail;
  }
  getFilingDetail() {
    const params: QualityGateDetailsFilter = {
      qualityGateType: "Duplicate_Filings",
      entryId: this.selectedFiling.entryId,
    };
    this.isLoading = true;
    this._qualityGateService.viewEntryDetails(params).subscribe({
      next: (value) => {
        this.duplicateFilingsEntryDetails =
          value.duplicateFilingEntryDetails ?? [];
      },
      error: (err) => {
        this.isLoading = false;
        this._messageService.add({
          summary: err.error.message,
          severity: "error",
        });
      },
      complete: () => {
        this.paginator.totalCount =
          this.duplicateFilingsEntryDetails?.length ?? 0;
        this.isLoading = false;
      },
    });
  }
  pageChange(event: any) {
    this.first = event.first;
    this.rows = event.rows;
  }

  loadData(event: any) {
    if (event.first > 0 && this.paginator.pageSize != event.rows) {
      this.paginator.pageNumber = 1;
      this.first = 0;
    } else {
      this.paginator.pageNumber = event.first / event.rows + 1;
      this.first = event.first;
    }
    this.paginator.pageSize = event.rows;
    this.getFilingDetail();
  }

  onExcludeClick(share: any, status: string) {
    const submission: QualityGateSubmission = {
      qualityGateType: "Duplicate_Filings",
      missingSharesSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTypeOtherSubmission: {
        entryId: 0,
        updatedTransactionType: "",
      },
      transactionTypeBuySubmission: {
        entryId: 0,
      },
      missingSecurityBreakDownSubmission: {
        entryId: 0,
      },
      aggregateSharesValidationSubmission: {
        entryId: 0,
        indeterminable: false,
      },
      transactionTagsSubmission: {
        entryId: 0,
      },
      duplicateFilingSubmission: {
        entryId: share.entryId,
        entryDetailsId: share.entryDetailsId,
        status:
          status == "EXCLUDED"
            ? DuplicateFilingSubmissionStatus.EXCLUDED
            : DuplicateFilingSubmissionStatus.DUPLICATE,
      },
    };

    this._qualityGateService.submit(submission).subscribe({
      next: (response) => {
        this._messageService.add({
          severity: "success",
          summary: "Submission Successful",
          detail: "The record has been excluded successfully.",
        });
        // Refresh list from server
        this._qualityGateService
          .viewEntryDetails({
            qualityGateType: "Duplicate_Filings",
            entryId: this.selectedFiling.entryId,
          })
          .subscribe((value) => {
            this.duplicateFilingsEntryDetails =
              value.duplicateFilingEntryDetails ?? [];

            // ✅ Now check only after user action
            const allProcessed = this.duplicateFilingsEntryDetails.every(
              (item) =>
                item.status === "EXCLUDED" || item.status === "DUPLICATE"
            );

            if (allProcessed) {
              this.ref.close({ refresh: true });
            }
          });
      },
      error: (err) => {
        this._messageService.add({
          severity: "error",
          summary: "Submission Failed",
          detail: err?.error?.message || "An error occurred while submitting.",
        });
      },
    });
  }
}
